import styled from 'styled-components';
import { fontFamily, fontSize, fontWeight, screen } from '../../theme';

export const AppHeading1 = styled.h1`
  font-family: ${fontFamily('sans')};
  font-weight: ${fontWeight('extraBold')};
  font-size: ${fontSize('xl3')};
  line-height: 1.125;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl4')};
    line-height: 1.1;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl5')};
    line-height: 1.1666;
  }
`;

export const AppHeading2 = styled.h2`
  font-family: ${fontFamily('sans')};
  font-weight: ${fontWeight('extraBold')};
  font-size: ${fontSize('xl2')};
  line-height: 1.286;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl3')};
    line-height: 1.125;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl4')};
    line-height: 1.1;
  }
`;

export const AppHeading3 = styled.h3`
  font-family: ${fontFamily('sans')};
  font-weight: ${fontWeight('extraBold')};
  font-size: ${fontSize('xl')};
  line-height: 1.1666;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl2')};
    line-height: 1.286;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl3')};
    line-height: 1.125;
  }
`;

export const AppHeading4 = styled.h4`
  font-family: ${fontFamily('sans')};
  font-weight: ${fontWeight('extraBold')};
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl')};
    line-height: 1.1666;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl2')};
    line-height: 1.286;
  }
`;

export const AppHeading5 = styled.h5`
  font-family: ${fontFamily('sans')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('md')};
  line-height: 1.25;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    font-weight: ${fontWeight('extraBold')};
    line-height: 1.2;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl')};
    line-height: 1.1666;
  }
`;

export const AppHeading6 = styled.h6`
  font-family: ${fontFamily('sans')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('sm')};
  line-height: 1.143;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('md')};
    line-height: 1.25;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
    font-weight: ${fontWeight('extraBold')};
    line-height: 1.2;
  }
`;
